import auth0 from "auth0-js";

import { setToken, isTokenValid, removeToken, getProfile, getTokenExpiry, PREVIOUSLY_IN_INK } from '../utils/auth-jwt';
import { getData } from '../utils/fetch-api';
import storageFactory from '../utils/storage-factory';

const baseUrl = `${process.env.REACT_APP_API_URL}`;
const localStore = storageFactory();

class AuthService {

  constructor(domain) {
    this.auth = new auth0.WebAuth({
      domain:       `${process.env.REACT_APP_AUTH_DOMAIN}`,
      clientID:     `${process.env.REACT_APP_AUTH_CLIENT_ID}`,
      redirectUri:  `${window.location.origin}/callback`,
      responseType: 'token id_token',
      // Without an explicit scope, auth0-js defaults it only for authorize() —
      // checkSession() (silent renew) omits it, so the renewed idToken drops the
      // `name` claim and sender names surface as "undefined" (WWW-15656).
      scope:        'openid profile email',
    });
  }

  login() {
    this.auth.authorize();
  }

  loggedIn() {
    return isTokenValid();
  }

  async getUserProfile() {
    const profile = getProfile();
    const role = await getData(`${baseUrl}/auth/role`);
    return { ...profile, role };
  }

  logout() {
    removeToken();
    return this.auth.logout({
      returnTo: window.location.origin,
      clientID: `${process.env.REACT_APP_AUTH_CLIENT_ID}`,
    });
  }

  authenticate(callback, setIsLoading) {
    setIsLoading(true);
    this.auth.parseHash(async (error, authResult) => {
      if (error) {
        console.error(`Error ${error.error} occured`);
        return;
      }

      setToken(authResult.idToken);
      localStore.setItem(PREVIOUSLY_IN_INK, true);

      if (callback) {
        const profile = await this.getUserProfile();
        callback(profile);
      }
    });
  }

  renewSession() {
    this.auth.checkSession({}, (err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        setToken(authResult.idToken);
      } else if (err) {
        this.logout();
        console.error(`Could not get a new token (${err.error}: ${err.error_description}).`);
      }
    });
  }

  getTokenExpiration() {
    return getTokenExpiry();
  }
}

const authService = new AuthService();

export default authService;

